/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
import {Provider} from "react-redux";
import {Router} from "react-router-dom";
import {PersistGate} from "redux-persist/integration/react";
import {I18nProvider} from "./i18n";
import {LayoutSplashScreen, MaterialThemeProvider} from "./layout";
import {ToastContainer} from 'react-toastify';
import AppRouter from "../app/AppRouter";
import history from "../history";

export default function App({store, persistor, basename}) {
    return (
        /* Provide Redux store */
        <Provider store={store}>
            {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
            <PersistGate persistor={persistor} loading={<LayoutSplashScreen/>}>
                {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
                <React.Suspense fallback={<LayoutSplashScreen/>}>
                    {/* Override `basename` (e.g: `homepage` in `package.json`) */}
                    <Router history={history} basename={basename}>
                        {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
                        <MaterialThemeProvider>
                            {/* Provide `react-intl` context synchronized with Redux state.  */}
                            <I18nProvider>
                                {/* Render routes with provided `Layout`. */}
                                <AppRouter/>
                                {/* Toasts container. Here toasts are rendered */}
                                <ToastContainer/>

                            </I18nProvider>
                        </MaterialThemeProvider>
                    </Router>
                </React.Suspense>
            </PersistGate>
        </Provider>
    );
}
